import { useEffect, useMemo, useState } from 'react'
import useCustomEndpoint, { VALID_ENDPOINTS } from '@/hooks/useCustomEndpoint'
import { isEmpty, orderBy, snakeCase } from 'lodash'
import { wrap } from '@popmotion/popcorn'

const getHotels = (data) => {
  if (isEmpty(data)) return []
  const hotels = []

  data?.forEach((item, index) => {
    const hotelName = item?.select_label

    const name = hotelName

    const hotel = {
      index,
      hotel_ID: item?.hotel_ID,
      isFirst: index === 0,
      name: name,
      label: name,
      value: snakeCase(name),
      venues: item?.ourVenues,
      totalVenues: item?.ourVenues?.length || 0,
      order: item?.order,
    }

    hotels.push(hotel)
  })

  if (isEmpty(hotels)) return []

  return hotels
}

const getHotelData = (item) => {
  if (isEmpty(item)) return {}

  const hotelName = item?.select_label
  const name = hotelName

  return {
    name: name,
    label: name,
    value: snakeCase(name),
    venues: item?.ourVenues,
    siteUrl: item?.site_url,
    totalVenues: item?.ourVenues?.length,
  }
}

export default function useOurVenues() {
  const [hotels, setHotels] = useState([])
  const { data: allData, loading: allLoading } = useCustomEndpoint({
    type: VALID_ENDPOINTS.ourVenues,
    fetchOnMount: true,
  })
  const { loading: loadingHotelSelected, reFetchData: fetchVenuesByHotelId } = useCustomEndpoint({
    type: VALID_ENDPOINTS.ourVenues,
    fetchOnMount: false,
  })

  const [[venueCount, direction], setVenueCount] = useState([0, 0])

  const [currentHotel, setCurrentHotel] = useState({})

  const activeVenueIndex = useMemo(() => {
    const minValue = 0
    const maxValue = currentHotel?.totalVenues
    const currentIndex = venueCount

    const result = wrap(minValue, maxValue, currentIndex)

    return result
  }, [currentHotel?.totalVenues, venueCount])

  const swipeToVenue = (swipeDirection) => {
    setVenueCount([venueCount + swipeDirection, swipeDirection])
  }

  const dragEndHandler = (dragInfo) => {
    const draggedDistance = dragInfo.offset.x
    const swipeThreshold = 100
    const swipeThresholdNegative = -100

    if (draggedDistance > swipeThreshold) {
      swipeToVenue(-1)
    } else if (draggedDistance < swipeThresholdNegative) {
      swipeToVenue(1)
    }
  }

  const onChangeHotel = (item) => {
    if (isEmpty(item)) return

    fetchVenuesByHotelId({
      type: VALID_ENDPOINTS.ourVenues,
      params: { hotel_ID: item?.hotel_ID },
    }).then((response) => {
      const hotelData = getHotelData(response[0])

      const result = !isEmpty(hotelData) ? hotelData : {}

      setCurrentHotel(result)
    })

    setVenueCount([0, 0])
  }

  const currentVenue = useMemo(() => {
    if (isEmpty(currentHotel)) return {}

    const _venue = currentHotel?.venues[activeVenueIndex]

    if (isEmpty(_venue)) return {}

    return _venue
  }, [currentHotel, activeVenueIndex])

  useEffect(() => {
    if (isEmpty(allData)) return

    const _hotels = getHotels(allData)

    const orderedData = orderBy(_hotels, ['order'], ['asc'])

    // setCurrentHotel(_hotels[0])

    onChangeHotel(orderedData[0])

    setHotels(orderedData)
  }, [allData])

  return {
    currentHotel,
    onChangeHotel,
    hotels,
    swipeToVenue,
    direction,
    activeVenueIndex,
    dragEndHandler,
    venueCount,
    currentVenue,
    allLoading,
    loadingHotelSelected,
  }
}
